import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { EditableQuestion } from '../../../../../../types';
import { StyledQuestionFieldContainer } from '../../styles';
import { StyledImageUploader } from './styles';

interface Props {
  control: Control<EditableQuestion>;
  imageUrl?: string | null;
}

const ImageEditor = ({ control, imageUrl }: Props) => (
  <Controller
    control={control}
    name="image"
    render={({ field }) => (
      <StyledQuestionFieldContainer>
        <StyledImageUploader
          onChange={file => {
            field.onChange({ target: { value: file } });
          }}
          onRemove={() => field.onChange({ target: { value: null } })}
          title="Question Image"
          url={field.value ? getFileAsUrl(field.value) : imageUrl || null}
        />
      </StyledQuestionFieldContainer>
    )}
  />
);


function getFileAsUrl(file?: File) {
  if (file instanceof Blob) {
    return URL.createObjectURL(file);
  }

  return null;
}

export default ImageEditor;
